







































import { defineComponent, ref } from "@nuxtjs/composition-api";
import { Product } from '~/utils/types/Product';
import { PropType } from "vue";
import { forEach } from "lodash-es";
import { SfIcon } from "@storefront-ui/vue";
import Price from "~/components/Price.vue";
import AddToCart from "~/components/AddToCart.vue";
import { formatDate } from "~/utils/helpers/functions";
export default defineComponent({
  components: {
    SfIcon,
    Price,
    AddToCart
  },
  props: {
    items: {
      type: Array as PropType<Product[]>,
    },
  },
  setup(props) {
    /**
     * Object like : {1: true, 2: false .... (items.length-1): false} to manage transitions openings
     */
    let tmp = {};
    [...Array(props.items.length).keys()].forEach((element) => {
      tmp[element] = false;
    });
    const opened = ref<Object>(tmp);

    const items = ref<Product[]>(props.items);
    forEach(items.value, (item) => {
      item["data_pubblicazione"] = formatDate(item["data_pubblicazione"]);
    });

    return {
      products: items,
      opened,
    };
  },
});
